/* VCTparts fitting finder: "Welke fitting heb ik nodig?" (snippets/fitting-zoeker.liquid).
   Moved out of the snippet so the browser caches it; the shop language
   texts, plate lookup switch, links and page mode come from the #gfz-config
   JSON that the snippet renders. See the snippet for how the finder works. */
(function(){
  if (window.__gfzInitialized) return;
  var cfgEl = document.getElementById("gfz-config");
  if (!cfgEl) return;
  window.__gfzInitialized = true;
  /* Winkeltaal, teksten en links uit de snippet (#gfz-config) */
  var CFG = {};
  try { CFG = JSON.parse(cfgEl.textContent) || {}; } catch(e){ return; }

  /* -------- Vertalingen (winkeltaal via Liquid; nl = standaard) -------- */
  var I18N = CFG.i18n || {};
  function t(key, vars){
    return String(I18N[key] == null ? key : I18N[key]).replace(/%\{(\w+)\}/g, function(_, k){ return vars && vars[k] != null ? vars[k] : ""; });
  }
  /* -------- Iconen: dezelfde lijniconen als snippets/vct-icon.liquid -------- */
  var ICON_PATHS = {
    "check": '<path d="M20 6 9 17l-5-5"/>',
    "arrow-right": '<path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>',
    "cart": '<circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/>',
    "info": '<circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/>',
    "alert": '<path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"/><path d="M12 9v4"/><path d="M12 17h.01"/>',
    "truck": '<path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/>'
  };
  function svgIcon(name, size, cls){
    size = size || 20;
    return '<svg class="vct-icon' + (cls ? " " + cls : "") + '" width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + ICON_PATHS[name] + '</svg>';
  }
  /* Kentekenchecker alleen in de Nederlandse winkeltaal (RDW = alleen NL) */
  var PLATE_ENABLED = !!CFG.plate;
  /* Taalprefix voor links (bijv. "/de"), zodat links in de juiste winkeltaal blijven */
  var ROOT = String(CFG.root || "/").replace(/\/$/, "");
  /* Vertaalde URL van de verlichting-collectie (handle verschilt per taal) */
  var LIGHTING_URL = CFG.lightingUrl || "/collections/verlichting";

  /* -------- Supabase (tabel "Fittingzoeker 2") -------- */
  var SB_URL = "https://boxzsvsedjiahzggnvqx.supabase.co/rest/v1/Fittingzoeker%202";
  var SB_KEY = "sb_publishable_TEpUqI7C9M9-8cOlP8_yNA_hJA0829y"; /* publieke anon key */
  /* -------- RDW open data (kenteken, gratis, geen sleutel) -------- */
  var RDW_URL = "https://opendata.rdw.nl/resource/m9d7-ebf2.json";

  /* -------- Paginacontext: op een halogeen- of xenon-productpagina
     adviseert de kiezer halogeen/xenon in plaats van LED -------- */
  var PAGE_MODE = CFG.pageMode || "led";
  var MODE_TERM = { led: "LED", halogeen: "Halogeen", xenon: "Xenon" };
  var MODE_NAME = { led: t("modeLed"), halogeen: t("modeHalogen"), xenon: t("modeXenon") };
  /* Zoekterm per lampcode: xenon-codes (D1S, D3S, ...) horen altijd bij
     xenon-branders, wat de paginacontext ook is. */
  function searchTermFor(code){
    if (/^D\d/i.test(String(code || ""))) return code + " Xenon";
    return code + " " + MODE_TERM[PAGE_MODE];
  }

  /* -------- Merkenlijst (statisch; verandert zelden) -------- */
  var MAKES = ["Acura","Alfa Romeo","Audi","Austin","BMW","Buick","Cadillac","Chevrolet","Chrysler","Citroen","Dacia","Daewoo","Daihatsu","Dodge","Fiat","Ford","GMC","Honda","Hummer","Hyundai","Infiniti","Isuzu","Iveco","Jaguar","Jeep","Kia","Lada","Lancia","Land Rover","Lexus","Lincoln","Lotus","Maybach","Mazda","Mercedes-Benz","Mercury","MG","MINI","Mitsubishi","Nissan","Oldsmobile","Opel","Peugeot","Pontiac","Porsche","Proton","RAM","Reliant","Renault","Rolls-Royce","Rover","Saab","Saturn","Scion","SEAT","Skoda","smart","SsangYong","Subaru","Suzuki","Talbot","Toyota","Volkswagen","Volvo"];

  var TECH_LABELS = {
    "halogeen": t("techHalogen"),
    "xenon (HID)": t("techXenon"),
    "LED": t("techLed"),
    "gloeilamp": t("techBulb")
  };
  /* Gloeilamp en halogeen zijn voor de klant hetzelfde: één keuzegroep */
  function techGroup(t){
    if (t === "xenon (HID)") return "xenon";
    if (t === "LED") return "led";
    return "halogeen"; /* halogeen + gloeilamp + onbekend */
  }
  var GROUP_LABELS = { "halogeen": t("techHalogen"), "xenon": t("techXenon"), "led": t("techLed") };
  var GROUP_ORDER = ["halogeen", "xenon", "led"];

  /* Nette weergave van namen (filteren gebeurt altijd op de ruwe
     databasewaarde). BMW "3" wordt "3 Serie", Mercedes "C-CLASS" wordt
     "C-Klasse", en SCHREEUWENDE hoofdletters worden netjes gezet. */
  function displayModel(make, model){
    var m = String(model || "");
    if (make === "BMW") {
      if (/^\d$/.test(m)) return m + " Serie";
      if (/^\d[\s]/.test(m)) m = m.replace(/^(\d)/, "$1 Serie");
    }
    m = m.replace(/-CLASS\b/gi, "-Klasse").replace(/\bCLASS\b/gi, "Klasse").replace(/\bSERIES\b/gi, "Serie");
    /* Woorden van 4+ letters in volledige hoofdletters netjes zetten;
       korte codes (CL, CLK, GTI, CRV) blijven zoals ze zijn. */
    m = m.replace(/\b[A-Z]{4,}\b/g, function(w){
      return w.charAt(0) + w.slice(1).toLowerCase();
    });
    return m;
  }
  var CURRENT_YEAR = new Date().getFullYear();

  /* ================================================================
     Modelnaam-parser: haalt de generatie uit de modelnaam.
     "GOLF VI"        -> basis "GOLF",  generatie 6
     "GOLF Mk III"    -> basis "GOLF",  generatie 3
     "GOLF V VARIANT" -> basis "GOLF",  generatie "5 Variant"
     "MULTIVAN T5"    -> basis "MULTIVAN", generatie "T5"
     "3" / "C-CLASS"  -> geen token; generatie komt dan uit de
                         kolom "generation" (E90, W204, ...).
     ================================================================ */
  function romanToInt(w){
    if (!/^[IVX]+$/.test(w)) return 0;
    var map = { I: 1, V: 5, X: 10 }, n = 0;
    for (var i = 0; i < w.length; i++) {
      var v = map[w.charAt(i)], nx = map[w.charAt(i + 1)] || 0;
      n += v < nx ? -v : v;
    }
    return (n >= 1 && n <= 20) ? n : 0;
  }
  function normBase(s){
    s = String(s || "").toUpperCase().replace(/\s+/g, " ").trim();
    /* "C CLASS" en "C-CLASS" zijn hetzelfde model */
    s = s.replace(/\b([A-Z]{1,3}) CLASS\b/g, "$1-CLASS");
    return s;
  }
  function parseModel(model){
    var words = String(model || "").replace(/\s+/g, " ").trim().split(" ");
    for (var i = 1; i < words.length; i++) {
      var w = words[i].toUpperCase(), m, gnum = 0, glabel = "", end = i;
      if ((m = /^MK([IVX]+|\d{1,2})$/.exec(w))) {
        gnum = romanToInt(m[1]) || parseInt(m[1], 10) || 0;
        glabel = String(gnum);
      } else if (w === "MK" && i + 1 < words.length) {
        var nx = words[i + 1].toUpperCase();
        var nv = romanToInt(nx) || (/^\d{1,2}$/.test(nx) ? parseInt(nx, 10) : 0);
        if (nv) { gnum = nv; glabel = String(nv); end = i + 1; }
      } else if (romanToInt(w)) {
        gnum = romanToInt(w);
        glabel = String(gnum);
      } else if (/^T[1-7]$/.test(w)) {
        gnum = parseInt(w.charAt(1), 10);
        glabel = w; /* T5, T6 - zo heten die generaties echt */
      }
      if (gnum) {
        var suffix = words.slice(end + 1).join(" ").replace(/^[-–—]\s*/, "").trim();
        return { base: normBase(words.slice(0, i).join(" ")), gen: gnum, genLabel: glabel, suffix: suffix };
      }
    }
    return { base: normBase(String(model || "")), gen: 0, genLabel: "", suffix: "" };
  }
  /* Past een rij bij dit bouwjaar? (open einddatum = loopt door tot nu) */
  function rowMatchesYear(r, y){
    var from = parseInt(r.year_from, 10);
    var to = r.year_to == null || r.year_to === "" ? CURRENT_YEAR : parseInt(r.year_to, 10);
    if (isNaN(from)) from = 1900;
    if (isNaN(to)) to = CURRENT_YEAR;
    return from <= y && to >= y;
  }
  /* Rijen selecteren voor een bouwjaar: eerst op jaar filteren, daarna
     "nieuwste uitvoering wint" PER positie + verlichtingssoort. Een open
     einddatum (loopt door tot nu) vervalt alleen als er voor dezelfde
     positie MET dezelfde verlichtingssoort een nieuwere rij bestaat.
     Zo kan een halogeen-rij nooit een xenon-rij wegdrukken (of andersom)
     en blijft de halogeen/xenon-keuze altijd kloppen. */
  function selectRowsForYear(rows, y){
    var filtered = rows.filter(function(r){ return rowMatchesYear(r, y); });
    function pruneKey(r){
      return r.position_nl + "|" + techGroup(r.technology) + "|" + (r.is_alternative == 1 ? "a" : "m");
    }
    var maxStart = {};
    filtered.forEach(function(r){
      var s = parseInt(r.year_from, 10) || 0;
      var k = pruneKey(r);
      if (!maxStart[k] || s > maxStart[k]) maxStart[k] = s;
    });
    return filtered.filter(function(r){
      var open = r.year_to == null || r.year_to === "";
      if (!open) return true;
      var s = parseInt(r.year_from, 10) || 0;
      return s >= maxStart[pruneKey(r)];
    });
  }
  /* Bouwjaren-dropdown: alle jaren waarvoor dit model data heeft */
  function yearsFromRows(rows){
    var min = 9999, max = 0;
    rows.forEach(function(r){
      var from = parseInt(r.year_from, 10);
      var to = r.year_to == null || r.year_to === "" ? CURRENT_YEAR : parseInt(r.year_to, 10);
      if (!isNaN(from) && from < min) min = from;
      if (!isNaN(to) && to > max) max = to;
    });
    if (max > CURRENT_YEAR) max = CURRENT_YEAR;
    var out = [];
    for (var y = max; y >= min; y--) {
      for (var i = 0; i < rows.length; i++) { if (rowMatchesYear(rows[i], y)) { out.push(y); break; } }
    }
    return out;
  }

  /* -------- State -------- */
  var state = { step:"form", make:null, model:null, modelLabel:null, year:null, tech:null };
  var modelsCache = {};   /* make -> { bases: [...], fulls: {base: [modelstrings]} } */
  var rowsCache = {};     /* make|base -> rijen */
  var renderToken = 0;
  var STORAGE_KEY = "gfzVehicle3";

  var PROGRESS = { form:35, result:100 };

  /* -------- DOM -------- */
  var overlay = document.getElementById("gfz-overlay");
  var panel = document.getElementById("gfz-panel");
  var cartbar = document.getElementById("gfz-cartbar");
  var cartbarText = document.getElementById("gfz-cartbar-text");
  document.body.appendChild(overlay);
  document.body.appendChild(panel);
  document.body.appendChild(cartbar);
  var body = document.getElementById("gfz-body");
  var progressBar = document.getElementById("gfz-progress-bar");
  var backBtn = document.getElementById("gfz-back");
  var resetBtn = document.getElementById("gfz-reset");
  var closeBtn = document.getElementById("gfz-close");
  var openTrigger = document.getElementById("gfz-open-trigger");

  /* -------- Helpers -------- */
  function sbFetch(params){
    return fetch(SB_URL + "?" + params, {
      headers: { "apikey": SB_KEY, "Accept": "application/json" }
    }).then(function(res){
      if (!res.ok) throw new Error("api error " + res.status);
      return res.json();
    });
  }
  function esc(s){
    return String(s == null ? "" : s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;");
  }
  function loadSaved(){
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var v = JSON.parse(raw);
      if (v && v.make && v.model && v.year) return v;
    } catch(e){}
    return null;
  }
  function saveVehicle(){
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        make: state.make, model: state.model, modelLabel: state.modelLabel,
        year: state.year, tech: state.tech
      }));
    } catch(e){}
  }
  function clearSaved(){
    try { localStorage.removeItem(STORAGE_KEY); localStorage.removeItem(FIT_KEY); } catch(e){}
    notifyFit(null);
  }

  /* -------- Autoprofiel voor "Past in jouw auto" (assets/vct-fit.js) --------
     Per lamppositie de lampcodes van de gekozen auto. "sure" = de enige
     uitvoering op die positie; "maybe" = een van meerdere uitvoeringen of
     een alternatief (klant moet de code op de huidige lamp controleren). */
  var FIT_KEY = "gfzFit1";
  function vehicleKey(v){ return [v.make, v.model, v.year, v.tech || ""].join("|"); }
  function loadFit(){
    try { return JSON.parse(localStorage.getItem(FIT_KEY) || "null"); } catch(e){ return null; }
  }
  function notifyFit(profile){
    try { document.dispatchEvent(new CustomEvent("vct:fit", { detail: profile })); } catch(e){}
  }
  function saveFitProfile(v, grouped){
    var sure = {}, maybe = {};
    function add(map, code, pos){
      code = String(code || "").trim();
      if (!/\d/.test(code)) return; /* "LED" (af-fabriek) is geen losse lamp */
      if (!map[code]) map[code] = [];
      if (map[code].indexOf(pos) === -1) map[code].push(pos);
    }
    grouped.order.forEach(function(pos){
      var g = grouped.byPos[pos];
      if (g.mains.length === 1) add(sure, g.mains[0].bulb_type, pos);
      else g.mains.forEach(function(r){ add(maybe, r.bulb_type, pos); });
      g.alts.forEach(function(r){ add(maybe, r.bulb_type, pos); });
    });
    var profile = {
      v: 1, key: vehicleKey(v), make: v.make, model: v.modelLabel || v.model, year: v.year,
      sure: sure, maybe: maybe, vwH7: vwH7Holder(v)
    };
    try { localStorage.setItem(FIT_KEY, JSON.stringify(profile)); } catch(e){}
    notifyFit(profile);
  }
  var t_ = t;
  function updateBannerText(){
    var t = document.getElementById("gfz-banner-title");
    var s = document.getElementById("gfz-banner-sub");
    if (!t || !s) return;
    var v = loadSaved();
    if (v) {
      t.textContent = t_("savedTitle", { car: v.make + " " + (v.modelLabel || v.model) + (v.year ? " (" + v.year + ")" : "") });
      s.textContent = t_("savedSub");
    } else {
      t.textContent = t_("bannerTitle");
      s.textContent = t_("bannerSub");
    }
  }

  /* -------- Scroll-lock (iOS-proof) -------- */
  var scrollLockY = 0;
  function openPanel(skipSaved){
    if (skipSaved !== true && state.step === "form" && !state.make) {
      var v = loadSaved();
      if (v) {
        state.make = v.make; state.model = v.model; state.modelLabel = v.modelLabel || v.model;
        state.year = v.year;
        state.tech = v.tech || null; state.step = "result";
      }
    }
    overlay.classList.add("is-open");
    panel.classList.add("is-open");
    scrollLockY = window.scrollY || document.documentElement.scrollTop || 0;
    document.body.style.position = "fixed";
    document.body.style.top = (-scrollLockY) + "px";
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";
    document.body.style.overflow = "hidden";
    render();
  }
  function closePanel(){
    overlay.classList.remove("is-open");
    panel.classList.remove("is-open");
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.width = "";
    document.body.style.overflow = "";
    window.scrollTo(0, scrollLockY);
  }
  function resetAll(){
    clearSaved();
    updateBannerText();
    state = { step:"form", make:null, model:null, modelLabel:null, year:null, tech:null };
    render();
  }
  function goTo(step){ state.step = step; render(); }

  /* -------- Data -------- */
  function getModels(make){
    if (modelsCache[make]) return Promise.resolve(modelsCache[make]);
    return sbFetch("select=model&make=eq." + encodeURIComponent(make) + "&order=model&limit=100000")
      .then(function(rows){
        var fulls = {}, bases = [], seenFull = {};
        rows.forEach(function(r){
          if (!r.model || seenFull[r.model]) return;
          seenFull[r.model] = 1;
          var base = parseModel(r.model).base;
          if (!fulls[base]) { fulls[base] = []; bases.push(base); }
          fulls[base].push(r.model);
        });
        var out = { bases: bases, fulls: fulls };
        modelsCache[make] = out;
        return out;
      });
  }
  function getRows(make, base){
    var key = make + "|" + base;
    if (rowsCache[key]) return Promise.resolve(rowsCache[key]);
    var data = modelsCache[make];
    var fullList = (data && data.fulls[base]) || [base];
    var inList = "(" + fullList.map(function(m){ return '"' + String(m).replace(/"/g, '\\"') + '"'; }).join(",") + ")";
    var sel = "select=model,generation,variant,body,year_from,year_to,position_nl,position_order,bulb_type,fitting,technology,watts,is_alternative,bulb_note_nl";
    return sbFetch(sel + "&make=eq." + encodeURIComponent(make) + "&model=in." + encodeURIComponent(inList) + "&order=position_order&limit=10000")
      .then(function(rows){ rowsCache[key] = rows; return rows; });
  }
  /* Posities waar meerdere techniek-GROEPEN voorkomen (halogeen/gloeilamp
     telt als één groep) bepalen of de techniek-vraag nodig is. Andere
     posities worden nooit door de techniek-keuze gefilterd. */
  function multiTechInfo(rows){
    var perPos = {};
    rows.forEach(function(r){
      if (!perPos[r.position_nl]) perPos[r.position_nl] = {};
      perPos[r.position_nl][techGroup(r.technology)] = 1;
    });
    var multiPositions = {}, groups = {};
    Object.keys(perPos).forEach(function(pos){
      var g = Object.keys(perPos[pos]);
      if (g.length > 1) { multiPositions[pos] = 1; g.forEach(function(x){ groups[x] = 1; }); }
    });
    return { positions: multiPositions, techs: Object.keys(groups) };
  }

  /* -------- Render -------- */
  function header(title, sub){
    return '<span class="gfz-title">'+esc(title)+'</span><span class="gfz-sub">'+esc(sub)+'</span>';
  }
  function loadingHtml(){
    return '<div class="gfz-loading"><div class="gfz-spinner"></div>' + t("loading") + '</div>';
  }
  function errorHtml(){
    return '<div class="gfz-error">' + svgIcon("alert", 18) + '<span>' + t("loadError") + '</span></div>';
  }
  function render(){
    progressBar.style.width = (PROGRESS[state.step] || 0) + "%";
    backBtn.hidden = (state.step === "form");
    resetBtn.hidden = (state.step === "form");
    if (state.step === "form") renderForm();
    if (state.step === "result") renderResult();
  }

  /* -------- Formulier: kenteken + dropdowns -------- */
  function makeField(labelText, id){
    var f = document.createElement("div");
    f.className = "gfz-field";
    f.innerHTML = '<label for="'+id+'">'+esc(labelText)+'</label>' +
      '<select class="gfz-select" id="'+id+'"></select>';
    return f;
  }
  function fillSelect(sel, placeholder, options, selectedValue){
    sel.innerHTML = "";
    var ph = document.createElement("option");
    ph.value = "";
    ph.textContent = placeholder;
    sel.appendChild(ph);
    options.forEach(function(o){
      var opt = document.createElement("option");
      opt.value = o.value;
      opt.textContent = o.label;
      if (selectedValue != null && String(o.value) === String(selectedValue)) opt.selected = true;
      sel.appendChild(opt);
    });
  }
  function renderForm(){
    body.innerHTML = header(t("bannerTitle"), t("formSub"));

    /* Kentekenchecker */
    var plateWrap = document.createElement("div");
    if (PLATE_ENABLED) plateWrap.innerHTML =
      '<div class="gfz-plate">' +
        '<div class="gfz-plate__frame">' +
          '<span class="gfz-plate__eu" aria-hidden="true">' +
            '<img class="gfz-plate__stars" src="https://cdn.shopify.com/s/files/1/0871/5904/6480/files/European_stars_svg.webp?v=1787685146" alt="" loading="lazy">' +
            '<b>NL</b>' +
          '</span>' +
          '<input type="text" class="gfz-plate__input" id="gfz-plate-input" placeholder="XX-99-XX" maxlength="10" autocomplete="off" autocapitalize="characters" spellcheck="false" inputmode="text" aria-label="Kenteken">' +
        '</div>' +
        '<button type="button" class="gfz-plate__btn" id="gfz-plate-btn">Zoek auto</button>' +
      '</div>' +
      '<span class="gfz-plate__status" id="gfz-plate-status" aria-live="polite"></span>' +
      '<div class="gfz-divider"><span>of kies handmatig</span></div>';
    body.appendChild(plateWrap);

    var fMake = makeField(t("make"), "gfz-sel-make");
    var fModel = makeField(t("model"), "gfz-sel-model");
    var fYear = makeField(t("year"), "gfz-sel-year");
    var fTech = makeField(t("lighting"), "gfz-sel-tech");
    fTech.style.display = "none";
    body.appendChild(fMake);
    body.appendChild(fModel);
    body.appendChild(fYear);
    body.appendChild(fTech);
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "gfz-btn gfz-formbtn";
    btn.textContent = t("showFittings");
    btn.disabled = true;
    body.appendChild(btn);

    var selMake = fMake.querySelector("select");
    var selModel = fModel.querySelector("select");
    var selYear = fYear.querySelector("select");
    var selTech = fTech.querySelector("select");
    var plateInput = plateWrap.querySelector("#gfz-plate-input");
    var plateBtn = plateWrap.querySelector("#gfz-plate-btn");
    var plateStatusEl = plateWrap.querySelector("#gfz-plate-status");
    var techNeeded = false;
    var yearList = [];

    fillSelect(selMake, t("pickMake"), MAKES.map(function(m){ return { value: m, label: m }; }), state.make);
    selModel.disabled = true; fillSelect(selModel, t("pickMakeFirst"), [], null);
    selYear.disabled = true; fillSelect(selYear, t("pickModelFirst"), [], null);

    function plateStatus(msg, cls){
      var ic = cls === "is-ok" ? svgIcon("check", 16) : (cls === "is-err" ? svgIcon("alert", 16) : "");
      plateStatusEl.innerHTML = msg ? ic + "<span>" + esc(msg) + "</span>" : "";
      plateStatusEl.className = "gfz-plate__status" + (cls ? " " + cls : "");
    }
    function updateButton(){
      btn.disabled = !(state.make && state.model && state.year && (!techNeeded || state.tech));
    }
    function applyYearSelection(){
      if (!state.year) return Promise.resolve(false);
      return getRows(state.make, state.model).then(function(rows){
        /* Dezelfde selectie als het resultaat gebruikt, zodat de
           verlichting-vraag altijd klopt met wat er straks getoond wordt */
        updateTech(selectRowsForYear(rows, state.year));
        return techNeeded;
      }).catch(function(){ return false; });
    }
    function loadModels(cb){
      selModel.disabled = true;
      selModel.classList.add("is-loading");
      fillSelect(selModel, t("loadingModels"), [], null);
      var token = ++renderToken;
      getModels(state.make).then(function(data){
        if (token !== renderToken) return;
        var entries = data.bases.map(function(b){ return { value: b, label: displayModel(state.make, b) }; });
        entries.sort(function(a, b){ return a.label.localeCompare(b.label, "nl", { numeric: true }); });
        fillSelect(selModel, t("pickModel"), entries, state.model);
        selModel.disabled = false;
        selModel.classList.remove("is-loading");
        if (state.model) loadYears();
        if (cb) cb(data);
      }).catch(function(){
        if (token === renderToken) fillSelect(selModel, t("loadFailed"), [], null);
      });
    }
    function loadYears(cb){
      selYear.disabled = true;
      selYear.classList.add("is-loading");
      fillSelect(selYear, t("loadingYears"), [], null);
      var token = ++renderToken;
      getRows(state.make, state.model).then(function(rows){
        if (token !== renderToken) return;
        yearList = yearsFromRows(rows);
        fillSelect(selYear, t("pickYear"), yearList.map(function(y){ return { value: y, label: y }; }), state.year);
        selYear.disabled = false;
        selYear.classList.remove("is-loading");
        if (state.year) applyYearSelection();
        updateButton();
        if (cb) cb(yearList);
      }).catch(function(){
        if (token === renderToken) fillSelect(selYear, t("loadFailed"), [], null);
      });
    }
    function updateTech(filteredRows){
      var info = multiTechInfo(filteredRows);
      var groups = GROUP_ORDER.filter(function(g){ return info.techs.indexOf(g) !== -1; });
      techNeeded = groups.length > 1;
      if (techNeeded) {
        fTech.style.display = "";
        fillSelect(selTech, t("pickTech"), groups.map(function(g){ return { value: g, label: GROUP_LABELS[g] }; }), state.tech);
      } else {
        fTech.style.display = "none";
        state.tech = null;
      }
      updateButton();
    }

    selMake.addEventListener("change", function(){
      state.make = selMake.value || null;
      state.model = null; state.modelLabel = null; state.year = null; state.tech = null;
      techNeeded = false; fTech.style.display = "none";
      selYear.disabled = true; fillSelect(selYear, t("pickModelFirst"), [], null);
      updateButton();
      if (state.make) { loadModels(); } else { selModel.disabled = true; fillSelect(selModel, t("pickMakeFirst"), [], null); }
    });
    selModel.addEventListener("change", function(){
      state.model = selModel.value || null;
      state.modelLabel = state.model ? displayModel(state.make, state.model) : null;
      state.year = null; state.tech = null;
      techNeeded = false; fTech.style.display = "none";
      updateButton();
      if (state.model) { loadYears(); } else { selYear.disabled = true; fillSelect(selYear, t("pickModelFirst"), [], null); }
    });
    selYear.addEventListener("change", function(){
      state.year = selYear.value ? parseInt(selYear.value, 10) : null;
      state.tech = null;
      if (state.year) { applyYearSelection(); }
      else { fTech.style.display = "none"; techNeeded = false; }
      updateButton();
    });
    selTech.addEventListener("change", function(){
      state.tech = selTech.value || null;
      updateButton();
    });
    btn.addEventListener("click", function(){ if (!btn.disabled) goTo("result"); });

    /* ---------- Kenteken opzoeken via RDW ---------- */
    function matchMake(merk){
      var M = String(merk || "").toUpperCase().trim();
      var i;
      for (i = 0; i < MAKES.length; i++) { if (MAKES[i].toUpperCase() === M) return MAKES[i]; }
      for (i = 0; i < MAKES.length; i++) {
        var u = MAKES[i].toUpperCase();
        if (M.indexOf(u) === 0 || u.indexOf(M) === 0) return MAKES[i];
      }
      return null;
    }
    function tokenize(s){
      return " " + String(s || "").toUpperCase().replace(/[^A-Z0-9]/g, " ").replace(/\s+/g, " ").trim() + " ";
    }
    function matchBase(bases, hbRaw, makeName){
      var hb = tokenize(hbRaw);
      var best = null, i;
      bases.forEach(function(b){
        var t = tokenize(b);
        if (t.trim() && hb.indexOf(t) !== -1 && (!best || t.length > best.t.length)) best = { b: b, t: t };
      });
      if (best) return best.b;
      if (makeName === "BMW") {
        /* RDW-benamingen: "316I", "116D", maar ook "1ER REIHE" / "3ER REIHE"
           (Duitse serienaam) en "M3". Allemaal terugbrengen tot het
           seriecijfer. */
        var m = / ([1-8])ER(?: REIHE)? /.exec(hb) ||
                / ([1-8])\d\d[A-Z]* /.exec(hb) ||
                / M([1-8]) /.exec(hb);
        if (m) { for (i = 0; i < bases.length; i++) { if (bases[i] === m[1]) return bases[i]; } }
      }
      if (makeName === "Mercedes-Benz") {
        var m2 = / (CLA|CLK|CLS|CLC|CL|GLA|GLB|GLC|GLE|GLS|GLK|GL|SLK|SLC|SLR|SL|ML|EQA|EQB|EQC|EQE|EQS|[ABCEGSVR]) ?\d/.exec(hb);
        if (m2) {
          var L = m2[1];
          for (i = 0; i < bases.length; i++) {
            if (bases[i] === L || bases[i].indexOf(L + "-") === 0 || bases[i].indexOf(L + " ") === 0) return bases[i];
          }
        }
      }
      return null;
    }
    function pickYear(years, y){
      if (!y || !years.length) return null;
      var best = null, bestDiff = 1e9;
      years.forEach(function(yy){
        var d = Math.abs(yy - y);
        if (d < bestDiff) { bestDiff = d; best = yy; }
      });
      /* Alleen automatisch kiezen als het (vrijwel) exact klopt; anders
         eerlijk aan de klant vragen. */
      return bestDiff <= 1 ? best : null;
    }
    /* RDW-namen netjes maken: "A4 AVANT" wordt "A4 Avant". Bekende
       afkortingen (TDI, TFSI, ...) en codes met cijfers blijven staan. */
    function niceName(s){
      var KEEP = /^(TFSI|TSI|TDI|FSI|CDI|CDTI|CRDI|DCI|HDI|JTD|TCE|THP|GTI|GTD|GTE|VTEC|MPI|XDRIVE|SDRIVE|AWD|4WD|EV|PHEV)$/;
      return String(s || "").replace(/\s+/g, " ").trim().split(" ").map(function(w){
        var W = w.toUpperCase();
        if (KEEP.test(W) || /\d/.test(W) || W.length <= 2) return W;
        return W.charAt(0) + W.slice(1).toLowerCase();
      }).join(" ");
    }
    /* Nette omschrijving van de gevonden auto voor de statusregel */
    function buildCarName(makeStr, hbStr, modelLbl, y){
      var name = niceName(hbStr);
      /* BMW's Duitse "1ER REIHE" zegt een klant niets */
      if (/ER REIHE/i.test(hbStr || "")) name = modelLbl || "";
      if (!name) name = modelLbl || "";
      /* Merk zit soms al in de handelsnaam (bijv. "AUDI A4"):
         niet dubbel tonen */
      var mk = String(makeStr || "").toUpperCase();
      var nu = name.toUpperCase();
      if (nu === mk) name = modelLbl || "";
      else if (nu.indexOf(mk + " ") === 0) name = name.slice(mk.length + 1);
      var out = makeStr + (name ? " " + name : "");
      if (y) out += " uit " + y;
      return out;
    }
    /* Automatisch streepjes zetten terwijl je typt (werkt voor alle
       NL sidecodes: bij elke wissel letters<->cijfers komt een streepje,
       en vier gelijke tekens op rij worden 2+2, zoals GV-BB-12). */
    function formatPlate(raw){
      var s = String(raw || "").toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 8);
      if (!s) return "";
      var groups = [], cur = s.charAt(0);
      for (var i = 1; i < s.length; i++) {
        var isD = /\d/.test(s.charAt(i));
        var wasD = /\d/.test(cur.charAt(cur.length - 1));
        if (isD === wasD) cur += s.charAt(i);
        else { groups.push(cur); cur = s.charAt(i); }
      }
      groups.push(cur);
      var out = [];
      groups.forEach(function(g){
        if (g.length === 4) { out.push(g.slice(0, 2)); out.push(g.slice(2)); }
        else { out.push(g); }
      });
      return out.join("-");
    }
    if (plateInput) plateInput.addEventListener("input", function(){
      var v = formatPlate(plateInput.value);
      if (v !== plateInput.value) plateInput.value = v;
    });
    function lookupPlate(){
      var plate = String(plateInput.value || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
      if (plate.length < 4) { plateStatus("Vul een geldig kenteken in.", "is-err"); return; }
      /* Belgisch formaat (1-ABC-123): niet opzoekbaar, alleen NL is open data */
      if (/^[1-9][A-Z]{3}\d{3}$/.test(plate)) {
        plateStatus("Dat lijkt een Belgisch kenteken. Alleen Nederlandse kentekens zijn opzoekbaar. Kies je auto hieronder handmatig.", "is-err");
        return;
      }
      plateBtn.disabled = true;
      plateStatus("Kenteken opzoeken…", "");
      fetch(RDW_URL + "?kenteken=" + encodeURIComponent(plate), { headers: { "Accept": "application/json" } })
        .then(function(res){ if (!res.ok) throw new Error("rdw"); return res.json(); })
        .then(function(arr){
          plateBtn.disabled = false;
          if (!arr || !arr.length) { plateStatus("Kenteken niet gevonden. Controleer het, of kies hieronder handmatig (buitenlandse kentekens zijn niet opzoekbaar).", "is-err"); return; }
          var v = arr[0];
          var makeName = matchMake(v.merk);
          var hb = v.handelsbenaming || "";
          var year = parseInt(String(v.datum_eerste_toelating || "").substr(0, 4), 10) || null;
          if (!makeName) {
            plateStatus("Gevonden: " + buildCarName(niceName(v.merk), hb, null, year) + ". Dit merk staat nog niet in onze database. Kies je auto hieronder handmatig.", "is-err");
            return;
          }
          state.make = makeName; state.model = null; state.modelLabel = null; state.year = null; state.tech = null;
          techNeeded = false; fTech.style.display = "none";
          selMake.value = makeName;
          var carName = buildCarName(makeName, hb, null, year);
          plateStatus("Gevonden: " + carName + ". Gegevens invullen…", "");
          loadModels(function(data){
            var baseKey = matchBase(data.bases, hb, makeName);
            if (!baseKey) {
              plateStatus("Gevonden: " + carName + ". Kies hieronder nog je model.", "is-ok");
              updateButton();
              return;
            }
            state.model = baseKey;
            state.modelLabel = displayModel(makeName, baseKey);
            carName = buildCarName(makeName, hb, state.modelLabel, year);
            selModel.value = baseKey;
            if (selModel.value !== baseKey) {
              /* optie ontbreekt onverwacht: laat de klant zelf kiezen */
              state.model = null; state.modelLabel = null;
              plateStatus("Gevonden: " + carName + ". Kies hieronder nog je model.", "is-ok");
              updateButton();
              return;
            }
            loadYears(function(years){
              var y = pickYear(years, year);
              if (!y) {
                plateStatus("Gevonden: " + carName + ". Kies hieronder nog het bouwjaar.", "is-ok");
                updateButton();
                return;
              }
              state.year = y;
              selYear.value = String(y);
              carName = buildCarName(makeName, hb, state.modelLabel, y);
              applyYearSelection().then(function(needTech){
                updateButton();
                if (needTech) {
                  plateStatus("Gevonden: " + carName + ". Kies alleen nog welke verlichting er nu in zit.", "is-ok");
                } else {
                  /* Alles bekend: direct door naar het resultaat */
                  plateStatus("Gevonden: " + carName + ". Alles klopt, het resultaat wordt geladen…", "is-ok");
                  setTimeout(function(){
                    if (state.step === "form" && state.make && state.model && state.year) goTo("result");
                  }, 600);
                }
              });
            });
          });
        })
        .catch(function(){
          plateBtn.disabled = false;
          plateStatus("De kentekencheck is nu niet bereikbaar. Kies hieronder handmatig.", "is-err");
        });
    }
    if (plateBtn) plateBtn.addEventListener("click", lookupPlate);
    if (plateInput) plateInput.addEventListener("keydown", function(e){ if (e.key === "Enter") { e.preventDefault(); lookupPlate(); } });

    /* Voorgeselecteerde waarden (terugkomen vanaf resultaat) */
    if (state.make) loadModels();
    updateButton();
  }

  /* Rijen voor bouwjaar en techniek, ontdubbeld en gesorteerd: positie,
     hoofd eerst. Bij een duplicaat wint de rij ZONDER variant-aanduiding
     (algemene uitvoering). */
  function buildList(rows, year, tech){
    var filtered = selectRowsForYear(rows, year);
    var info = multiTechInfo(filtered);
    if (tech) {
      filtered = filtered.filter(function(r){
        return !info.positions[r.position_nl] || techGroup(r.technology) === tech;
      });
    }
    var seen = {}, list = [];
    filtered.forEach(function(r){
      var k = [r.position_nl, r.bulb_type, r.fitting, r.technology, r.is_alternative].join("|");
      if (seen[k] === undefined) { seen[k] = list.length; list.push(r); }
      else if (list[seen[k]].variant && !r.variant) { list[seen[k]] = r; }
    });
    list.sort(function(a, b){
      return (a.position_order - b.position_order) || (a.is_alternative - b.is_alternative);
    });
    return list;
  }
  function groupByPos(list){
    var order = [], byPos = {};
    list.forEach(function(r){
      if (!byPos[r.position_nl]) { byPos[r.position_nl] = { mains: [], alts: [] }; order.push(r.position_nl); }
      if (r.is_alternative == 1) { byPos[r.position_nl].alts.push(r); } else { byPos[r.position_nl].mains.push(r); }
    });
    return { order: order, byPos: byPos };
  }

  function renderResult(){
    var logoUrl = "https://cdn.shopify.com/s/files/1/0871/5904/6480/files/carlogo-" +
      String(state.make || "").toLowerCase().replace(/\s+/g, "-") + ".png";
    body.innerHTML =
      '<div class="gfz-resulthead">' +
        '<img class="gfz-resulthead__logo" src="' + logoUrl + '" alt="' + esc(state.make) + ' logo" loading="lazy" onerror="this.style.display=\'none\'">' +
        '<div>' +
          '<span class="gfz-title">' + t("resultTitle") + '</span>' +
          '<span class="gfz-sub">' + t("resultSub") + '</span>' +
        '</div>' +
      '</div>';
    var chips = document.createElement("div");
    chips.className = "gfz-chips";
    [state.make, state.modelLabel || state.model, state.year, state.tech ? (GROUP_LABELS[state.tech] || state.tech) : null].forEach(function(val){
      if (!val) return;
      var chip = document.createElement("button");
      chip.type = "button";
      chip.className = "gfz-chip";
      chip.innerHTML = svgIcon("check", 16) + "<b>"+esc(val)+"</b>";
      chip.addEventListener("click", function(){ goTo("form"); });
      chips.appendChild(chip);
    });
    body.appendChild(chips);
    var slot = document.createElement("div");
    slot.innerHTML = loadingHtml();
    body.appendChild(slot);
    var token = ++renderToken;
    getModels(state.make).then(function(){
      return getRows(state.make, state.model);
    }).then(function(rows){
      if (token !== renderToken || state.step !== "result") return;
      var list = buildList(rows, state.year, state.tech);
      slot.innerHTML = "";
      if (!list.length) {
        slot.innerHTML = '<div class="gfz-error">' + svgIcon("info", 18) + '<span>' + t("noData") + '</span></div>';
      } else {
        saveVehicle();
        updateBannerText();
        /* Groepeer per lamppositie */
        var grouped = groupByPos(list);
        var order = grouped.order, byPos = grouped.byPos;
        saveFitProfile(state, grouped);
        function yearsStr(r){
          var f = parseInt(r.year_from, 10);
          if (isNaN(f)) return "";
          var until = (r.year_to == null || r.year_to === "") ? t("present") : r.year_to;
          return f + "-" + until;
        }
        function lampHtml(r, isAlt, showYears){
          var meta = [];
          if (r.technology) meta.push(TECH_LABELS[r.technology] || r.technology);
          if (r.watts) meta.push(esc(r.watts) + "W");
          if (showYears) { var ys = yearsStr(r); if (ys) meta.push(ys); }
          if (r.variant) meta.push(esc(t("variantLabel")) + esc(displayModel(state.make, r.variant)));
          if (r.body) meta.push(esc(displayModel(state.make, r.body)));
          if (r.bulb_note_nl) meta.push(esc(r.bulb_note_nl));
          return '<div class="gfz-lamp' + (isAlt ? " is-alt" : "") + '">' +
            '<span class="gfz-bulb">' + esc(r.bulb_type) + '</span>' +
            '<div class="gfz-lamp__info">' +
              '<span class="gfz-lamp__fit">' + esc(t("fittingLabel")) + esc(r.fitting) + (isAlt ? '<span class="gfz-altlabel">' + esc(t("alternative")) + '</span>' : "") + '</span>' +
              (meta.length ? '<span class="gfz-lamp__meta">' + meta.join(" · ") + '</span>' : "") +
            '</div>' +
            '<a class="gfz-shoplink" href="' + (vwSpecificH7Applies(r.bulb_type) ? ROOT + '/products/' + VW_H7_HANDLE : ROOT + '/search?q=' + encodeURIComponent(searchTermFor(r.bulb_type))) + '">' + t("view") + svgIcon("arrow-right", 16) + '</a>' +
          '</div>';
        }
        var hasMulti = false;
        var groupsHtml = "";
        order.forEach(function(pos){
          var g = byPos[pos];
          var inner = "";
          var multi = g.mains.length > 1;
          if (multi) {
            hasMulti = true;
            var codes = g.mains.map(function(r){ return r.bulb_type; }).join(" " + t("or") + " ");
            inner += '<div class="gfz-poshint"><b>' + esc(codes) + '?</b> ' + t("posHint") + '</div>';
          }
          g.mains.forEach(function(r, i){
            if (i > 0) inner += '<div class="gfz-or"><span>' + esc(t("or")) + '</span></div>';
            inner += lampHtml(r, false, multi);
          });
          g.alts.forEach(function(r){ inner += lampHtml(r, true, false); });
          groupsHtml += '<div class="gfz-posgroup"><div class="gfz-posgroup__head">' + esc(pos) + '</div>' + inner + '</div>';
        });
        var helpHtml = hasMulti
          ? '<div class="gfz-help">' + svgIcon("info", 18) + '<span>' + t("help") + '</span></div>'
          : "";
        slot.innerHTML = helpHtml + groupsHtml +
          '<span class="gfz-note">' + t("note", { car: esc(state.make) + ' ' + esc(state.modelLabel || state.model) + ' (' + esc(state.year) + ')' }) + '</span>';
        /* Posities die automatisch geadviseerd kunnen worden: precies één
           hoofduitvoering. Posities met meerdere uitvoeringen slaan we over
           (klant moet eerst zelf de code controleren). */
        var eligible = [], skipped = [];
        order.forEach(function(pos){
          var g = byPos[pos];
          if (g.mains.length === 1) { eligible.push({ pos: pos, code: g.mains[0].bulb_type }); }
          else if (g.mains.length > 1) { skipped.push(pos); }
        });
        /* Adviseer-CTA prominent BOVENIN het resultaat */
        var adviceWrap = document.createElement("div");
        if (eligible.length) {
          var cta = document.createElement("div");
          cta.className = "gfz-advisecta";
          var adviseNaam = (eligible.length && eligible.every(function(e){ return /^D\d/i.test(e.code); })) ? t("modeXenon") : MODE_NAME[PAGE_MODE];
          cta.innerHTML =
            '<span class="gfz-advisecta__title">' + t("adviseTitle", { name: adviseNaam }) + '</span>' +
            '<span class="gfz-advisecta__sub">' + t("adviseSub", { car: esc(state.make) + ' ' + esc(state.modelLabel || state.model) }) + '</span>' +
            '<button type="button" class="gfz-btn" id="gfz-advise">' + t("adviseBtn") + '</button>';
          slot.insertBefore(adviceWrap, slot.firstChild);
          slot.insertBefore(cta, slot.firstChild);
          cta.querySelector("#gfz-advise").addEventListener("click", function(){
            cta.style.display = "none";
            renderAdvisor(adviceWrap, eligible, skipped);
          });
        }
        var actions = document.createElement("div");
        actions.className = "gfz-footeractions";
        actions.innerHTML =
          '<a href="' + LIGHTING_URL + '" class="gfz-btn gfz-btn--ghost" style="text-decoration:none !important;">' + t("allLighting") + '</a>' +
          '<button type="button" class="gfz-btn gfz-btn--ghost" id="gfz-again">' + t("otherCar") + '</button>';
        slot.appendChild(actions);
        actions.querySelector("#gfz-again").addEventListener("click", resetAll);
      }
    }).catch(function(){ if (token === renderToken) slot.innerHTML = errorHtml(); });
  }

  /* ================================================================
     Lampenset-adviseur: zoekt per lamppositie het beste product.
     Merkvolgorde: 1) HaloVision, 2) AMiO F25, 3) AMiO Hybrid,
     4) overige AMiO, 5) andere merken.
     Binnen die volgorde wint ECHTE voorraad (1 of hoger) ALTIJD van
     "0 voorraad maar wel bestelbaar" - zo voorkomen we backorders.
     Pas als geen enkel passend product voorraad heeft, pakken we de
     beste bestelbare optie (de hele bestelling wordt dan backorder).
     Voorraadstatus komt uit de producttag "gfz-uitverkocht" (staat op
     producten met 0 voorraad). Product zonder die tag = op voorraad.
     ================================================================ */
  var CART_ICON = svgIcon("cart", 20);
  var cartCount = 0;
  var productJsCache = {};
  function fmMoney(cents){ return "€" + (cents/100).toFixed(2).replace(".", ","); }
  function escRe(s){ return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); }
  function codeMatches(code, text){
    if (!text) return false;
    return new RegExp("(^|[^A-Za-z0-9])" + escRe(code) + "([^A-Za-z0-9]|$)", "i").test(text);
  }
  var EXCLUDE_RE = /decoder|weerstand|belasting|adapter|verloop|houder|socket|ombouw|kabel|tester/i;
  function searchProducts(code){
    var url = "/search/suggest.json?q=" + encodeURIComponent(searchTermFor(code)) +
      "&resources[type]=product&resources[limit]=10" +
      "&resources[options][unavailable_products]=show&resources[options][fields]=title,tag";
    return fetch(url, { headers: { "Accept": "application/json" } })
      .then(function(res){ return res.json(); })
      .then(function(data){
        var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        return products.filter(function(p){
          var text = (p.title || "") + " " + (p.tags || []).join(" ");
          if (EXCLUDE_RE.test(p.title || "")) return false;
          /* In halogeen/xenon-modus alleen producten van dat type (en geen LED) */
          if (PAGE_MODE !== "led") {
            if (!(new RegExp(MODE_TERM[PAGE_MODE], "i")).test(text)) return false;
            if (/\bled\b/i.test(text)) return false;
          }
          if (codeMatches(code, p.title)) return true;
          var tags = p.tags || [];
          for (var i = 0; i < tags.length; i++) { if (codeMatches(code, tags[i])) return true; }
          return false;
        });
      });
  }
  /* Merkvolgorde: lager nummer = eerder kiezen.
     0 = HaloVision, 1 = AMiO F25, 2 = AMiO Hybrid, 3 = overige AMiO,
     4 = andere merken. Matcht op vendor én titel (vendor is soms leeg
     in suggest-resultaten). */
  function brandRank(p){
    var text = (String(p.vendor || "") + " " + String(p.title || "")).toLowerCase();
    if (text.indexOf("halovision") !== -1) return 0;
    var isAmio = /(^|[^a-z])amio/.test(text);
    if (isAmio && text.indexOf("f25") !== -1) return 1;
    if (isAmio && text.indexOf("hybrid") !== -1) return 2;
    if (isAmio) return 3;
    return 4;
  }
  /* -------- Voorraadstatus via de producttag "gfz-uitverkocht" --------
     Producten met 0 voorraad dragen deze tag. Geen tag = op voorraad. */
  var OOS_TAG = "gfz-uitverkocht";
  function hasOosTag(tags){
    if (!tags) return false;
    for (var i = 0; i < tags.length; i++) {
      if (String(tags[i]).toLowerCase() === OOS_TAG) return true;
    }
    return false;
  }
  /* Eerste bestelbare variant van een product (null = niets bestelbaar) */
  function firstAvailableVariant(pj){
    for (var i = 0; i < pj.variants.length; i++) {
      if (pj.variants[i].available) return pj.variants[i];
    }
    return null;
  }
  function productJs(handle){
    if (productJsCache[handle]) return Promise.resolve(productJsCache[handle]);
    return fetch("/products/" + handle + ".js", { headers: { "Accept": "application/json" } })
      .then(function(res){ if (!res.ok) throw new Error("nf"); return res.json(); })
      .then(function(p){ productJsCache[handle] = p; return p; });
  }
  /* VW-specifieke H7: deze Volkswagen-modellen gebruiken bij originele
     halogeen koplampen de VW-kunststof H7-houder (5K0941109-familie).
     Een gewone H7 LED past daar niet direct in - adviseer dan de
     HaloVision VW-specifieke Direct Fit H7. Jaartallen zijn indicatief
     per generatie; de disclaimer vraagt altijd om controle. */
  var VW_H7_HANDLE = "halovision-volkswagen-specifieke-h7-led-40w-8000lm-6000k-direct-fit-zonder-adapters-golf-6-7-passat-touran-tiguan-scirocco";
  var VW_H7_MODELS = [
    { re: /golf/i, from: 2008, to: 2020 },       /* Golf 6/7, Cabrio, Variant, Sportsvan, GTI, R, e-Golf */
    { re: /jetta/i, from: 2010, to: 2018 },      /* Jetta 6 */
    { re: /passat/i, from: 2010, to: 2022 },     /* B7/B8 met halogeen */
    { re: /tiguan/i, from: 2007, to: 2020 },     /* 5N + bepaalde MQB */
    { re: /scirocco/i, from: 2008, to: 2018 },
    { re: /sharan/i, from: 2010, to: 2022 },     /* 7N */
    { re: /eos/i, from: 2006, to: 2016 },
    { re: /touran/i, from: 2015, to: 2099 },     /* Touran II / 5T */
    { re: /t-?roc/i, from: 2018, to: 2099 },
    { re: /transporter|caravelle|multivan/i, from: 2009, to: 2099 },
    { re: /crafter/i, from: 2006, to: 2017 }     /* 2E/2F */
  ];
  function vwH7Holder(v){
    if (v.make !== "Volkswagen") return false;
    for (var i = 0; i < VW_H7_MODELS.length; i++) {
      var m = VW_H7_MODELS[i];
      if (m.re.test(String(v.model)) && v.year >= m.from && v.year <= m.to) return true;
    }
    return false;
  }
  function vwSpecificH7Applies(code){
    if (PAGE_MODE !== "led") return false; /* alleen bij LED-upgrade advies */
    if (String(code).toUpperCase() !== "H7") return false;
    return vwH7Holder(state);
  }
  function findForCode(code){
    if (vwSpecificH7Applies(code)) {
      /* VW-specifiek gaat altijd voor (een gewone H7 past hier niet direct),
         ook bij 0 voorraad - dan wel netjes als backorder gemarkeerd. */
      return productJs(VW_H7_HANDLE).then(function(pj){
        var v = firstAvailableVariant(pj);
        if (!v) return findForCodeGeneric(code); /* niet bestelbaar: val terug op gewoon advies */
        return {
          title: pj.title,
          url: ROOT + "/products/" + VW_H7_HANDLE,
          image: pj.featured_image || (pj.images && pj.images[0]) || null,
          cents: v.price,
          variantId: v.id,
          vendor: pj.vendor || "",
          backorder: hasOosTag(pj.tags),
          vwNote: t("vwNote")
        };
      }).catch(function(){ return findForCodeGeneric(code); });
    }
    return findForCodeGeneric(code);
  }
  function findForCodeGeneric(code){
    return searchProducts(code).then(function(cands){
      if (!cands || !cands.length) return null;
      /* Sorteer op merkvolgorde en loop de kandidaten af. Het EERSTE
         bestelbare product ZONDER uitverkocht-tag wint (= voorraad >= 1).
         Producten die wel bestelbaar zijn maar de uitverkocht-tag dragen
         (0 voorraad, backorder) onthouden we alleen als reserve-optie
         voor als niets met voorraad gevonden wordt. */
      var ranked = cands.slice().sort(function(a, b){ return brandRank(a) - brandRank(b); });
      var MAX_CHECK = 6; /* max aantal productpagina's per lampcode raadplegen */
      var fallback = null;   /* beste bestelbare optie zonder voorraad */
      var lastResort = null; /* uitverkochte AMiO als allerlaatste redmiddel */
      function toResult(pj, handle, v, backorder){
        return {
          title: pj.title,
          url: ROOT + "/products/" + handle,
          image: pj.featured_image || (pj.images && pj.images[0]) || null,
          cents: v.price,
          variantId: v.id,
          vendor: pj.vendor || "",
          backorder: backorder
        };
      }
      function tryNext(i){
        if (i >= ranked.length || i >= MAX_CHECK) return Promise.resolve(fallback || lastResort);
        var p = ranked[i];
        var handle = p.handle || (p.url || "").split("/products/")[1];
        if (!handle) return tryNext(i + 1);
        handle = handle.split("?")[0];
        /* Draagt dit zoekresultaat de uitverkocht-tag en hebben we al een
           reserve-optie? Dan is de productpagina ophalen niet meer nodig. */
        if (hasOosTag(p.tags) && fallback) return tryNext(i + 1);
        return productJs(handle).then(function(pj){
          var v = firstAvailableVariant(pj);
          var oos = hasOosTag(pj.tags) || hasOosTag(p.tags);
          if (v && !oos) {
            return toResult(pj, handle, v, false); /* op voorraad: klaar */
          }
          if (v && oos && !fallback) {
            fallback = toResult(pj, handle, v, true);
          }
          if (!v && !lastResort && String(pj.vendor || "").toLowerCase().indexOf("amio") !== -1 && pj.variants && pj.variants[0]) {
            lastResort = toResult(pj, handle, pj.variants[0], true);
          }
          return tryNext(i + 1);
        }).catch(function(){ return tryNext(i + 1); });
      }
      return tryNext(0);
    }).catch(function(){ return null; });
  }
  /* Kortingsstaffel (zelfde als winkelbreed), berekend per stuk over de
     aangevinkte set: duurste product 0%, op een na duurste -5%, elk
     volgend product -10%. Geeft ook per regel de was/nu-prijs terug zodat
     de klant per product ziet welke korting hij krijgt. */
  function setTierTotals(items){
    var units = [];
    items.forEach(function(it, li){
      for (var i = 0; i < it.qty; i++) units.push({ line: li, cents: it.product.cents });
    });
    units.sort(function(a, b){ return b.cents - a.cents; });
    var perLine = items.map(function(it){ return { was: 0, now: 0, pct: 0 }; });
    var totalWas = 0, total = 0;
    units.forEach(function(u, i){
      var d = Math.min(i * 5, 10);
      var now = Math.round(u.cents * (100 - d) / 100);
      totalWas += u.cents; total += now;
      perLine[u.line].was += u.cents;
      perLine[u.line].now += now;
    });
    perLine.forEach(function(l){
      l.pct = l.was > l.now ? Math.round((l.was - l.now) / l.was * 100) : 0;
    });
    return { was: totalWas, now: total, perLine: perLine };
  }
  function renderAdvisor(container, positions, skippedPositions){
    container.innerHTML = '<div class="gfz-loading"><div class="gfz-spinner"></div>' + t("searching") + '</div>';
    /* positions: [{pos, code}] - alleen posities met precies 1 hoofduitvoering */
    var codes = {};
    positions.forEach(function(p){ if (!codes[p.code]) codes[p.code] = []; codes[p.code].push(p.pos); });
    var codeList = Object.keys(codes);
    /* Lampen die dim- en grootlicht in ÉÉN lamp combineren: xenon D-codes
       (bi-xenon met shutter) en duolampen zoals H4/H13/H15/HB1/HB5. Staat
       zo'n code op zowel Dimlicht als Grootlicht, dan is dat samen 1 set.
       Enkelvoudige lampen (bijv. H7 op beide posities) blijven 2 sets. */
    function isDualBeam(code){
      return /^D\d/i.test(code) || /^(H4|H13|H15|HB1|HB5|9004|9007)$/i.test(code);
    }
    function qtyFor(code, posList){
      var qty = posList.length;
      if (isDualBeam(code)) {
        var hasDim = posList.some(function(p){ return /dimlicht/i.test(p); });
        var hasHigh = posList.some(function(p){ return /grootlicht/i.test(p); });
        if (hasDim && hasHigh) qty -= 1; /* dim + groot = zelfde lamp */
      }
      return Math.max(1, qty);
    }
    Promise.all(codeList.map(findForCode)).then(function(results){
      var items = [], missing = [];
      codeList.forEach(function(code, i){
        var product = results[i];
        if (product) {
          items.push({ code: code, posList: codes[code], qty: qtyFor(code, codes[code]), product: product, checked: true });
        } else {
          missing.push({ code: code, posList: codes[code] });
        }
      });
      if (!items.length) {
        container.innerHTML = '<div class="gfz-error">' + svgIcon("info", 18) + '<span>' + t("noneInStock") + '</span></div>';
        return;
      }
      var box = document.createElement("div");
      box.className = "gfz-set";
      container.innerHTML = "";
      container.appendChild(box);
      function renderBox(){
        var sel = items.filter(function(it){ return it.checked; });
        var totals = setTierTotals(sel);
        var anyBackorder = sel.some(function(it){ return it.product.backorder; });
        /* per aangevinkte regel de staffelprijs opzoeken */
        var lineInfo = {};
        sel.forEach(function(it, si){ lineInfo[items.indexOf(it)] = totals.perLine[si]; });
        var rows = items.map(function(it, idx){
          var p = it.product;
          var img = p.image ? '<img src="'+p.image+'" alt="" loading="lazy">' : "";
          var posLabel = it.posList.join(" + ") +
            (it.qty > 1 ? " (" + it.qty + "x)" : (it.posList.length > 1 ? t("oneSet") : ""));
          var li = it.checked ? lineInfo[idx] : null;
          var priceHtml;
          if (li && li.pct > 0) {
            priceHtml = '<span class="gfz-set__price">'+fmMoney(li.now)+'</span>' +
              '<span class="gfz-set__was">'+fmMoney(li.was)+'</span>' +
              '<span class="gfz-disc">-'+li.pct+'%</span>';
          } else {
            priceHtml = '<span class="gfz-set__price">'+fmMoney(p.cents * it.qty)+'</span>';
          }
          return '<div class="gfz-set__item'+(it.checked ? ' is-checked' : '')+'" data-idx="'+idx+'">' +
            '<span class="gfz-set__check">'+(it.checked ? svgIcon("check", 16) : '')+'</span>' +
            '<div class="gfz-set__img">'+img+'</div>' +
            '<div class="gfz-set__info">' +
              '<span class="gfz-set__pos">'+esc(posLabel)+' · '+esc(it.code)+'</span>' +
              '<a class="gfz-set__name" href="'+p.url+'">'+esc(p.title)+'</a>' +
              '<span class="gfz-set__prices">' +
                priceHtml +
                (p.backorder ? '<span class="gfz-tag gfz-tag--backorder">' + esc(t("backorder")) + '</span>' : '') +
              '</span>' +
              (p.vwNote ? '<span class="gfz-set__pos" style="text-transform:none;letter-spacing:0;font-weight:600;">'+esc(p.vwNote)+'</span>' : '') +
            '</div>' +
          '</div>';
        }).join("");
        var missingHtml = missing.map(function(m){
          return '<div class="gfz-set__item is-missing">' +
            '<div class="gfz-set__info">' +
              '<span class="gfz-set__pos">'+esc(m.posList.join(" + "))+' · '+esc(m.code)+'</span>' +
              '<span class="gfz-set__name">' + esc(t("noProduct")) + '<a class="gfz-set__manual" href="' + ROOT + '/search?q='+encodeURIComponent(searchTermFor(m.code))+'">' + t("searchManually") + svgIcon("arrow-right", 14) + '</a></span>' +
            '</div>' +
          '</div>';
        }).join("");
        var discPct = totals.was > totals.now ? Math.round((totals.was - totals.now) / totals.was * 100) : 0;
        var totalHtml =
          '<span>' + t("total", { n: sel.reduce(function(n, it){ return n + it.qty; }, 0) }) + '</span>' +
          '<span class="gfz-set__totalprices">' +
            (discPct > 0 ? '<span class="gfz-set__totalwas">'+fmMoney(totals.was)+'</span>' : '') +
            '<span>'+fmMoney(totals.now)+'</span>' +
            (discPct > 0 ? '<span class="gfz-disc">-'+discPct+'%</span>' : '') +
          '</span>';
        var FREE_SHIPPING = 3900;
        var shipHtml = "";
        if (totals.now >= FREE_SHIPPING && totals.now > 0) {
          shipHtml = '<div class="gfz-set__shipping"><p class="gfz-set__shiptext is-free">' + svgIcon("check", 16) + '<span>' + t("freeShipping") + '</span></p><div class="gfz-set__shipbar"><span class="is-free" style="width:100%"></span></div></div>';
        } else if (totals.now > 0) {
          shipHtml = '<div class="gfz-set__shipping"><p class="gfz-set__shiptext">' + svgIcon("truck", 16) + '<span>' + t("untilFree", { amount: fmMoney(FREE_SHIPPING - totals.now) }) + '</span></p><div class="gfz-set__shipbar"><span style="width:'+Math.round(totals.now / FREE_SHIPPING * 100)+'%"></span></div></div>';
        }
        var backorderHtml = anyBackorder
          ? '<div class="gfz-set__notice">' + svgIcon("info", 18) + '<span>' + t("backorderNotice") + '</span></div>'
          : "";
        var skippedHtml = (skippedPositions && skippedPositions.length)
          ? '<div class="gfz-set__notice">' + svgIcon("info", 18) + '<span>' + t("skippedNotice", { pos: esc(skippedPositions.join(", ")) }) + '</span></div>'
          : "";
        var unitCount = sel.reduce(function(n, it){ return n + it.qty; }, 0);
        box.innerHTML =
          '<span class="gfz-set__badge">' + t("badge") + '</span>' +
          '<span class="gfz-set__title">' + t("setTitle", { car: esc(state.make)+' '+esc(state.modelLabel || state.model) }) + '</span>' +
          '<div class="gfz-set__items">'+rows+missingHtml+'</div>' +
          '<div class="gfz-set__total">'+totalHtml+'</div>' +
          shipHtml +
          backorderHtml +
          skippedHtml +
          '<button type="button" class="gfz-set__addbtn"'+(unitCount ? '' : ' disabled')+'>' +
            (unitCount ? CART_ICON + '<span>' + (unitCount === 1 ? t("addOne") : t("addMany", { n: unitCount })) + '</span>' : '<span>' + t("selectMin") + '</span>') +
          '</button>' +
          '<span class="gfz-set__fineprint">' + t("fineprint") + '</span>';
        box.querySelectorAll(".gfz-set__item[data-idx]").forEach(function(row){
          row.addEventListener("click", function(e){
            if (e.target.closest("a")) return;
            var idx = parseInt(row.getAttribute("data-idx"), 10);
            items[idx].checked = !items[idx].checked;
            renderBox();
          });
        });
        var addBtn = box.querySelector(".gfz-set__addbtn");
        if (unitCount) {
          addBtn.addEventListener("click", function(){
            var lines = sel.map(function(it){ return { id: it.product.variantId, quantity: it.qty }; });
            addToCart(lines, addBtn, unitCount);
          });
        }
      }
      renderBox();
    });
  }

  /* ---- Live cart-update (zelfde gelaagde aanpak als de Glossio-kiezer) ---- */
  function getThemeCartEl(){
    return document.querySelector("cart-notification") || document.querySelector("cart-drawer");
  }
  function updateCartCounters(itemCount){
    [".cart-count-bubble span[aria-hidden]", ".cart-count-bubble", "[data-cart-count]", ".cart-count", "#CartCount", ".cart-link__bubble-num", ".site-header__cart-count span", ".cart_count", ".cartCount"].forEach(function(sel){
      document.querySelectorAll(sel).forEach(function(el){
        if (el.hasAttribute("data-cart-count")) el.setAttribute("data-cart-count", itemCount);
        if (/^\s*\d+\s*$/.test(el.textContent)) el.textContent = itemCount;
      });
    });
  }
  function notifyThemeCartUpdated(cartData){
    ["cart:refresh","cart:updated","cart:change","cart:build","ajaxProduct:added"].forEach(function(name){
      try { document.dispatchEvent(new CustomEvent(name, { bubbles:true, detail:{ cart: cartData } })); } catch(e){}
    });
    try {
      if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined" && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "fitting-zoeker", cartData: cartData });
      }
    } catch(e){}
    try { if (window.Shopify && typeof window.Shopify.onCartUpdate === "function") window.Shopify.onCartUpdate(cartData); } catch(e){}
    /* Dit theme: ajaxCart vult de side-cart (aside#cart) en luistert naar "listCart" */
    try { if (window.ajaxCart && typeof window.ajaxCart.load === "function") window.ajaxCart.load(); } catch(e){}
    try { window.dispatchEvent(new CustomEvent("listCart")); } catch(e){}
  }
  function refreshThemeCart(){
    fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function(res){ return res.json(); })
      .then(function(cart){ updateCartCounters(cart.item_count); notifyThemeCartUpdated(cart); })
      .catch(function(){});
  }
  var kiezerAttrSet = false;
  function markKiezerOrder(){
    if (kiezerAttrSet) return;
    kiezerAttrSet = true;
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ attributes: { "Fitting Zoeker": "ja" } })
    }).catch(function(){ kiezerAttrSet = false; });
  }
  function addToCart(lines, btn, count){
    if (!lines || !lines.length) return;
    btn.disabled = true;
    var originalHtml = btn.innerHTML;
    btn.innerHTML = "<span>" + t("adding") + "</span>";
    var cartEl = getThemeCartEl();
    var payload = { items: lines };
    if (cartEl && typeof cartEl.renderContents === "function" && typeof cartEl.getSectionsToRender === "function") {
      try {
        payload.sections = cartEl.getSectionsToRender().map(function(s){ return s.id; });
        payload.sections_url = window.location.pathname;
      } catch(e){}
    }
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(payload)
    }).then(function(res){
      if (!res.ok) throw new Error("cart add failed");
      return res.json();
    }).then(function(response){
      cartCount += count;
      btn.innerHTML = svgIcon("check", 20, "gfz-icon-added") + "<span>" + t("addedCheck") + "</span>";
      cartbarText.textContent = t("addedCount", { n: cartCount });
      cartbar.classList.add("is-visible");
      clearTimeout(addToCart._t);
      addToCart._t = setTimeout(function(){ cartbar.classList.remove("is-visible"); }, 4000);
      markKiezerOrder();
      if (cartEl && typeof cartEl.renderContents === "function" && response.sections) {
        try { cartEl.renderContents(response); } catch(e){}
        try { if (typeof cartEl.close === "function") setTimeout(function(){ cartEl.close(); }, 50); } catch(e){}
      }
      refreshThemeCart();
      setTimeout(function(){ btn.innerHTML = originalHtml; btn.disabled = false; }, 1600);
    }).catch(function(){
      btn.innerHTML = "<span>" + t("addFailed") + "</span>";
      btn.disabled = false;
    });
  }

  /* -------- Grid-plaatsing (na 4e product; na 8e als de Glossio-kiezer
     daar al staat) -------- */
  function placeInGrid(){
    var grid = document.getElementById("collection");
    if (!grid || !openTrigger || openTrigger.closest(".gfz-grid-slot")) return;
    var slot = document.createElement("li");
    slot.className = "gfz-grid-slot";
    var children = Array.prototype.slice.call(grid.children);
    var hasOtherFinder = !!grid.querySelector(".gpf-grid-slot");
    var productCount = 0, anchor = null;
    var target = hasOtherFinder ? 8 : 4;
    for (var i = 0; i < children.length; i++) {
      if (children[i].classList.contains("gpf-grid-slot") || children[i].classList.contains("gfz-grid-slot")) continue;
      productCount++;
      if (productCount === target) { anchor = children[i]; break; }
    }
    if (anchor) { anchor.insertAdjacentElement("afterend", slot); } else { grid.appendChild(slot); }
    slot.appendChild(openTrigger);
  }
  function initGridPlacement(){
    /* kleine vertraging zodat een eventuele Glossio-kiezer eerst zijn plek pakt;
       daarna banner altijd tonen (ook als er geen grid is) */
    setTimeout(function(){
      placeInGrid();
      openTrigger.classList.remove("gfz-pending");
    }, 60);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initGridPlacement);
  } else {
    initGridPlacement();
  }

  /* -------- Openen via een link (#fittingzoeker) --------
     Een kenteken van de homepage staat in sessionStorage en wordt meteen
     opgezocht. */
  var HASH_RE = /^#(fittingzoeker|fitting-zoeker|lampzoeker)$/i;
  function openFromLink(){
    /* Kwam de klik uit het mobiele menu, dan eerst dat menu sluiten */
    if (document.documentElement.classList.contains("m2a") && typeof window.close_mobile_nav === "function") {
      try { window.close_mobile_nav(); } catch(e){}
    }
    var plate = null;
    try { plate = sessionStorage.getItem("vct-fz-plate"); sessionStorage.removeItem("vct-fz-plate"); } catch(e){}
    if (plate && PLATE_ENABLED) {
      state = { step:"form", make:null, model:null, modelLabel:null, year:null, tech:null };
      openPanel(true);
      var plateField = document.getElementById("gfz-plate-input");
      var plateGo = document.getElementById("gfz-plate-btn");
      if (plateField && plateGo) {
        plateField.value = plate;
        plateField.dispatchEvent(new Event("input"));
        plateGo.click();
      }
      return;
    }
    openPanel();
  }
  function checkHash(){
    if (!HASH_RE.test(location.hash)) return;
    try { history.replaceState(null, "", location.pathname + location.search); } catch(e){}
    openFromLink();
  }
  document.addEventListener("click", function(e){
    var link = e.target && e.target.closest ? e.target.closest('a[href*="#fittingzoeker"]') : null;
    if (!link) return;
    e.preventDefault();
    openFromLink();
  });
  window.addEventListener("hashchange", checkHash);

  /* Auto al gekozen maar nog geen (of een ouder) profiel: stil op de
     achtergrond aanmaken, zodat "Past in jouw auto" meteen werkt. */
  function refreshFitProfile(){
    var v = loadSaved();
    if (!v) return;
    var p = loadFit();
    if (p && p.v === 1 && p.key === vehicleKey(v)) return;
    getModels(v.make).then(function(){
      return getRows(v.make, v.model);
    }).then(function(rows){
      var list = buildList(rows, v.year, v.tech || null);
      if (list.length) saveFitProfile(v, groupByPos(list));
    }).catch(function(){});
  }

  /* -------- Events -------- */
  openTrigger.addEventListener("click", function(){ openPanel(); });
  openTrigger.addEventListener("keydown", function(e){ if (e.key === "Enter" || e.key === " ") { e.preventDefault(); openPanel(); } });
  closeBtn.addEventListener("click", closePanel);
  overlay.addEventListener("click", closePanel);
  document.addEventListener("keydown", function(e){ if (e.key === "Escape") closePanel(); });
  resetBtn.addEventListener("click", resetAll);
  backBtn.addEventListener("click", function(){
    if (state.step === "result") goTo("form");
  });

  updateBannerText();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", checkHash);
  } else {
    checkHash();
  }
  setTimeout(refreshFitProfile, 2500);
})();
